export default __webpack_public_path__ + "static/color-logo-b5cc5ed093918c71486ba1bf9c000715.png";